<template>
  <div
    class="modal fade"
    id="elementHistoryModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content msm-form-container">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ title }}</b>
          </h4>
          <label v-if="elementId" class="control-label nopadding"
            >ID: {{ elementId }}</label
          >
        </div>
        <div class="modal-body">
          <div class="element-history-modal-content">
            <table v-if="history.length > 0" class="table">
              <thead>
                <tr>
                  <th class="text-left" style="width: 30%">
                    {{ lang.HIS000 }}
                  </th>
                  <th class="text-left" style="width: 70%">
                    {{ lang.HIS001 }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="entry in history"
                  :key="entry.SurveyInstanceHistoryGuid"
                >
                  <td class="text-left">
                    <b>{{ entry.EntryCreatedByDisplayName }}</b>
                    <br />
                    <span class="entry-creation-timestamp">{{
                      globals.getLocalizedDateTimeFromUtcIsoTimestamp(
                        entry.EntryCreatedAt
                      )
                    }}</span>
                  </td>
                  <td class="text-left">{{ entry.Message }}</td>
                </tr>
              </tbody>
            </table>
            <span v-else>{{ lang.HIS002 }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <div style="grid-area: left">
            <button
              type="button"
              class="btn btn-raised btn-light"
              data-dismiss="modal"
              style="float: left"
              v-if="showExportButton"
              @click="exportSurveyInstance"
            >
              {{ lang.HIS011 }}
            </button>
          </div>
          <div style="grid-area: right; box-sizing: border-box">
            <button
              type="button"
              class="btn btn-raised btn-light"
              data-dismiss="modal"
            >
              {{ lang.HIS003 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UseSurveyInst from "../../../services/SurveyInstances";

export default {
  name: "ElementHistoryModal",
  data() {
    return {
      title: "",
      elementId: 0,
      history: [],

      // Needed for survey instance history export
      showExportButton: false,
      surveyInstanceGuid: null,

      lang: {
        HIS000: "Info",
        HIS001: "Action",
        HIS002: "No history entries available.",
        HIS003: "Close",
        HIS004: "Check History",
        HIS005: "Location History",
        HIS006: "History data request failed",
        HIS007: "Project History",
        HIS008: "User History",
        HIS009: "Shopper History",
        HIS010: "Survey History",
        HIS011: "Download Check Answer History",
        HIS012: "Export",
        HIS013: "Check history export failed",
      },
    };
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.$off("showElementHistory");
    this.globals.$on("showElementHistory", (config) => {
      this.getElementHistory(config);
    });
  },
  methods: {
    openModal() {
      $("#elementHistoryModal").modal("show");
    },
    closeModal() {
      $("#elementHistoryModal").modal("hide");
    },
    getElementHistory(config) {
      if (!config) return;
      let query = "";
      switch (config.type) {
        case "Location":
          query = `api/LocationHistory/${config.guid}`;
          this.title = this.lang.HIS005;
          break;

        case "Survey":
          query = `api/SurveyHistory/${config.guid}`;
          this.title = this.lang.HIS010;
          break;

        case "SurveyInstance":
          query = `api/SurveyInstanceHistory/${config.guid}`;
          this.showExportButton = true;
          this.surveyInstanceGuid = config.guid;
          this.title = this.lang.HIS004;
          break;

        case "Project":
          query = `api/ProjectHistory/${config.guid}`;
          this.title = this.lang.HIS007;
          break;

        case "User":
          query = `api/UserHistory/${config.guid}`;
          this.title = this.lang.HIS008;
          break;

        case "Shopper":
          query = `api/ShopperHistory/${config.guid}`;
          this.title = this.lang.HIS009;
          break;

        default:
          break;
      }

      if (!query) {
        console.error("History config error");
        return;
      }

      this.elementId = config.id;
      this.history = [];
      // Use new type for this one
      if (config.type === "SurveyInstance") {
        UseSurveyInst.getHistoryByGUID(config.guid)
          .then((res) => {
            let data = res.data;
            if (data[0]) this.history = data;
            this.openModal();
          })
          .catch((err) => {
            console.error(err.msg);
            this.globals.showErrorSnackbar(err.Error);
          });
        return;
      }
      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data[0]) this.history = data;
          this.openModal();
        },
        error: (error) => {
          console.error("Error on GET in getElementHistory()");
          this.globals.showErrorSnackbar(this.lang.HIS006);
        },
      });
    },
    exportSurveyInstance() {
      if (!this.surveyInstanceGuid) return;
      let query = `api/SurveyInstanceAnswerHistory/${this.surveyInstanceGuid}/Export/`;

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          this.globals.downloadFile(data[0].DownloadId);
        },
        error: () => {
          console.error("Export failed");
          this.globals.showErrorSnackbar(this.lang.HIS013);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-lg {
  max-width: 900px;
}
.modal-header {
  padding-bottom: 0;
}
.modal-body {
  padding: 10px;
}
.modal-footer {
  padding-top: 0;
}
.element-history-modal-content {
  max-height: calc(100vh - 195px);
  overflow: auto;

  & > .table > thead > tr > th {
    border-top: none;
  }
}
.entry-creation-timestamp {
  font-size: 12px;
}
.modal-footer {
  display: -ms-grid;
  display: grid;
  grid-template-areas: "left middle right";
}
</style>



// WEBPACK FOOTER //
// ElementHistoryModal.vue?045ae7e5